<template>
  <v-container>
    <v-row xs12 class="mt-2 mb-3">
        <v-col sm="6">
          <v-row>Name: {{ table.name }}</v-row>
          <v-row>Players: {{ (table.players || []).length }}</v-row>
          <v-row>Waiting List: {{ (table.waiting_list || []).length }}</v-row>
        </v-col>
        <v-col sm="6">
          <v-row>
            <v-spacer/>
            <v-btn
              color="error"
              :disabled="table.status === 'ENDED'"
              @click="endTable"
              :loading="loading"
            >
            End Event
            </v-btn>
            <v-tooltip bottom>
              <template  v-slot:activator="{ on }">
                  <v-icon
                      v-on="on"
                      class="ml-2"
                  >
                    mdi-information-outline
                  </v-icon>
              </template>
              <span>Event is ended, Users can no longer view this table, activate it to allow them view it</span>
            </v-tooltip>
          </v-row>
        </v-col>
    </v-row>
    <v-row xs12 class="mb-3">
      <v-card width="100%">
        <v-toolbar flat>
          <v-toolbar-title>Player List</v-toolbar-title>
          <v-spacer/>
          <v-toolbar-items>
            <v-tooltip bottom>
              <template  v-slot:activator="{ on }">
                <v-btn
                    icon
                    v-on="on"
                    @click="add_player_modal = !add_player_modal"
                    :disabled="table.status === 'ENDED'"
                >
                  <v-icon color="success">mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Add a user to player list</span>
            </v-tooltip>
          </v-toolbar-items>
        </v-toolbar>
        <v-data-table
            :headers="playersListHeaders"
            :items="table.players"
        >
          <template v-slot:[`item.first_name`]="{ item }">
            {{ `${item.first_name} ${item.last_name}` }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
                v-model="item.checked"
                icon
                color="error"
                @click="removeFromPlayerModal(item)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-row>
    <v-row xs12>
      <v-card width="100%">
        <v-toolbar flat>
          <v-toolbar-title>Waiting List</v-toolbar-title>
          <v-spacer/>
          <v-btn
              v-if="checkedRequests.length > 0"
              color="success"
              @click="addToPlayerList"
          >
            Add to Player List
          </v-btn>
        </v-toolbar>
        <v-data-table
            :headers="waitListHeaders"
            :items="table.waiting_list"
        >
          <template v-slot:[`item.first_name`]="{ item }">
            {{ `${item.first_name} ${item.last_name}` }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row>
              <v-checkbox
                  v-model="item.checked"
                  @click="checkItemToBatch(item._id)"
              />
              <v-btn
                  @click="removeFromWaitListModal(item)"
                  color="red"
                  icon
                  class="mt-3"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-row>
    <v-dialog v-model="remove_player_modal" width="40%">
        <v-card>
          <v-container>
          <v-card-text>
            <p>
              Are you sure you want to remove player
              ({{ player_to_remove.first_name }} {{ player_to_remove.last_name }}) from player list?
            </p>
            <b>This Action cannot be undone</b>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-spacer/>
              <v-btn @click="remove_player_modal = false">Cancel</v-btn>
              <v-btn color="error" @click="removeFromPlayerList" :loading="loading">Remove</v-btn>
            </v-row>
          </v-card-actions>
          </v-container>
        </v-card>
    </v-dialog>
    <v-dialog v-model="add_player_modal" width="40%">
      <AddPlayer v-if="add_player_modal" :table-id="$route.params.id" @close="add_player_modal = false"/>
    </v-dialog>
    <v-dialog v-model="remove_from_wait_list_modal" width="40%">
      <v-card>
        <v-card-title>Remove Player from Wait list </v-card-title>
        <v-card-text>
          Are you sure you want to remove {{ player_to_remove.first_name }} {{ player_to_remove.last_name }} from the wait list?
        </v-card-text>
        <v-card-actions>
            <v-spacer/>
            <v-btn @click="remove_from_wait_list_modal = false">Cancel</v-btn>
            <v-btn @click="removeFromWaitList" color="red">Remove</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import AddPlayer from "@/components/forms/AddPlayer";
export default {
  name: "TableView",
  components: {AddPlayer},
  data() {
    return {
      playersListHeaders: [
        { value: 'first_name', text: 'Name' },
        { value: 'user_name', text: 'User Name' },
        { value: 'email', text: 'Email' },
        { value: 'actions', text: 'Actions' },
      ],
      waitListHeaders: [
        { value: 'first_name', text: 'Name' },
        { value: 'user_name', text: 'User Name' },
        { value: 'email', text: 'Email' },
        { value: 'actions', text: 'Actions' },
      ],
      checkedRequests: [],
      player_to_remove: {},
      add_player_modal: false,
      remove_from_wait_list_modal: false,
      remove_player_modal: false,
      loading: false,
      loading1: false,
      loading2: false,
    }
  },
  methods: {
    checkItemToBatch(id) {
      if (this.checkedRequests.indexOf(id) >= 0) {
        this.checkedRequests = this.checkedRequests.filter((_id) => _id !== id)
      } else {
        this.checkedRequests.push(id)
      }
    },

    async addToPlayerList() {
      this.loading2 = !this.loading2
      const players = this.checkedRequests
      await this.$store.dispatch('TABLE_ADD_PLAYERS', {
        players,
        _id: this.$route.params.id
      })
      this.loading2 = !this.loading2
    },

    async removeFromPlayerModal(player) {
      this.player_to_remove = player
      this.remove_player_modal = !this.remove_player_modal
    },

    async removeFromWaitListModal(player) {
      this.player_to_remove = player
      this.remove_from_wait_list_modal = !this.remove_from_wait_list_modal
    },

    async removeFromPlayerList() {
      this.loading2 = !this.loading2
      await this.$store.dispatch('TABLE_REMOVE_PLAYERS', {
        player_id: this.player_to_remove._id,
        _id: this.$route.params.id
      })
      this.remove_player_modal = !this.remove_player_modal
      this.loading2 = !this.loading2
    },

    async removeFromWaitList() {
      this.loading2 = !this.loading2
      await this.$store.dispatch('TABLE_REMOVE_FROM_WAIT_LIST', {
        player_id: this.player_to_remove._id,
        _id: this.$route.params.id
      })
      this.remove_from_wait_list_modal = !this.remove_from_wait_list_modal
      this.loading2 = !this.loading2
    },

    async endTable() {
      this.loading = !this.loading
      await this.$store.dispatch('END_TABLE', {
        _id: this.$route.params.id
      })
      this.loading = !this.loading
    }
  },
  computed: {
    table() {
      return this.$store.getters.table
    }
  },
  watch: {
    table(v) {
      return v || {}
    }
  },
  created() {
    this.$store.dispatch('GET_TABLE', { id: this.$route.params.id })
  }
}
</script>

<style scoped>

</style>